import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { Field } from 'formik';
import yup from 'yup';
import { Alert, Button, Row, Col, Icon, Tooltip, message, Spin } from 'antd';

import { postUser } from 'actions/asyncActions';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import withForm from 'components/hocs/withForm';
import Input from 'components/common/form/Input';
import Checkbox from 'components/common/form/Checkbox';
import { validationRegister } from 'components/common/cards/UserForm';
import { passwordGenerator } from '../../../utils/passwordGenrator';


@withAutoFocusForm
@withAsyncActions({
    formAction: postUser
}, { resetOnMount: true })
@withForm({
    validationSchema: yup.object({
        ...validationRegister,
        opd: yup.bool().oneOf([true], 'Требуется согласие').required(),
        spd: yup.bool().oneOf([true], 'Требуется согласие').required(),
    }),
    handleSubmit: (values, { props: { formAction } }) => {
        formAction.dispatch({ user: values });
    }
})

export default class SigninForm extends Component {

    constructor() {
        super()
        this.state = {
            password: "password",
            password_confirmation: "password",
            toggle: true,
            generatePassword: null
        }
    }

    generate = () => {
        const { setFieldValue } = this.props;
        let password = passwordGenerator()

        if(!/\d/.test(password)) {
            password += Math.floor(Math.random() * 10);
        }
        
        this.setState({ 
            generatePassword: password,
            password: 'text',
        })

        setFieldValue("password", password)
        message.warning('Запишите или сохраните сгенерированный пароль')
    }

    showPassword = (name) => {
        const { toggle } = this.state
        if(toggle) return this.setState({
                [name]: "text",
                toggle: false
            })
        
        this.setState({
            [name]: "password",
            toggle: true
        })
    }

    copyPassword = () => {
        const input = document.createElement('input')
        input.value = this.state.generatePassword
        document.body.appendChild(input);
        input.select()
        document.execCommand("copy")
        document.body.removeChild(input);
        message.success('Скопирован')

    }

    render() {
        const { meta } = this.props.formAction;

        const { password, password_confirmation, generatePassword } = this.state
        
        if (meta.success) {
            return (
                <Alert message="Заявка на регистрацию успешно отправлена." type="success" />
            );
        }

        return (
            <div className="signin-form required-mark-form" style={{opacity: meta.pending ? 0.6 : 1}}>
                <Row gutter={30}>
                    <Col xs={24} className="form-label">
                        Персональные данные
                    </Col>
                    <Col xs={24} sm={24}>
                        <Field
                            name='name'
                            component={Input}
                            placeholder='Имя'
                        />
                    </Col>
                    <Col xs={24} sm={24}>
                        <Field
                            name='surname'
                            component={Input}
                            placeholder='Фамилия'
                        />
                    </Col>
                    <Col xs={24} sm={24}>
                        <Field
                            name='email'
                            component={Input}
                            placeholder='E-mail'
                        />
                    </Col>
                    <Col xs={24} sm={24} className="form-box">
                        <Field
                            name='password'
                            type={password}
                            component={Input}
                            placeholder='Пароль'
                        />
                        {   
                            generatePassword && 
                            
                            <div onClick={this.copyPassword} className="form-box__icon form-box__icon_2">
                                <Tooltip title="Скопировать" >
                                    <Icon type="copy" />
                                </Tooltip>
                            </div>
                        }
                        <div onClick={this.generate} className="form-box__icon form-box__icon_1">
                            <Tooltip title="Сгенерировать пароль" >
                                <Icon type="key" />
                            </Tooltip>
                        </div>
                        <div onClick={()=> this.showPassword('password')} className="form-box__icon">
                            <Icon type={password === "password" ? "eye-invisible" : "eye"} />
                        </div>
                    </Col>
                    <Col xs={24} sm={24} className="form-box">
                        <Field
                            name='password_confirmation'
                            type={password_confirmation}
                            component={Input}
                            placeholder='Повторите пароль'
                        />
                        <div onClick={()=> this.showPassword('password_confirmation')} className="form-box__icon">
                            <Icon type={password_confirmation === "password" ? "eye-invisible" : "eye"} />
                        </div>
                    </Col>
                </Row>
                <Row className="form-row">
                    <Col xs={24}>
                        <Field
                            name='opd'
                            component={Checkbox}
                            additionalText={(
                                <span>
                                    Согласие на <a className="link-control" href="/docs/opd.pdf" target="_blank">обработку персональных данных</a>
                                </span>
                            )}
                        />
                    </Col>
                    <Col xs={24}>
                        <Field
                            name='spd'
                            component={Checkbox}
                            additionalText={(
                                <span>
                                    Согласие на получение <a className="link-control" href="/docs/mailing.pdf" target="_blank"> рекламных рассылок</a>
                                </span>
                            )}
                        />
                    </Col>
                </Row>
                <Row className="form-row m-b-20">
                    <Button
                        type='primary'
                        size='large'
                        htmlType='submit'
                        disabled={meta.pending}
                    >
                        Зарегистрироваться
                    </Button>
                </Row>
                {
                    meta.pending && 
                    <div className="signin-form__spin">
                        <Spin />
                    </div>    
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/landing/SigninForm.js